/**
 * Recommander la fiche d'un membre à un autre membre, par message.
 *
 * C'est un message ordinaire de type « profile_share » dont le contenu est un petit
 * JSON : la fiche (identifiant public et nom) et un mot facultatif. La messagerie
 * affiche une carte avec un bouton « Voir la fiche ».
 */

export const TYPE_MESSAGE_FICHE = 'profile_share';

const UUID = /^[0-9A-Fa-f]{8}(-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/;

/**
 * @returns {string} Le contenu à envoyer
 */
export function construireContenuFiche({ uuid, nom, note }) {
    return JSON.stringify({
        v: 1,
        uuid: String(uuid || ''),
        nom: String(nom || '').slice(0, 120),
        note: String(note || '').trim().slice(0, 500)
    });
}

/**
 * Lit le contenu d'un message de type fiche. Le contenu vient d'un autre membre : on ne
 * fait confiance à rien, et un identifiant qui n'a pas la forme d'un UUID est refusé
 * (il finit dans une adresse de page).
 *
 * @returns {{uuid: string, nom: string, note: string}|null}
 */
export function lireContenuFiche(contenu) {
    try {
        const d = JSON.parse(contenu);
        if (!d || typeof d !== 'object' || !UUID.test(String(d.uuid || ''))) return null;
        return {
            uuid: String(d.uuid),
            nom: typeof d.nom === 'string' ? d.nom : '',
            note: typeof d.note === 'string' ? d.note : ''
        };
    } catch {
        return null;
    }
}

/**
 * Le texte à montrer dans la liste des conversations à la place du JSON brut.
 * Un message ordinaire passe tel quel.
 */
export function apercuMessage(contenu, libelleFiche) {
    const fiche = lireContenuFiche(contenu);
    if (fiche) return `${libelleFiche || 'Fiche'} : ${fiche.nom}`.trim();
    if (typeof contenu === 'string' && contenu.startsWith('{"v":1,"uuid"')) return libelleFiche || 'Fiche';
    return contenu;
}
